"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/ElectricPlug.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ElectricPlug = function ElectricPlug(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 143.7 177.99"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Electric Plug Icon"), _react2.default.createElement("path", {
    className: "electric-plug",
    d: "M138.7 37.13l-36.7.09L101.69 5a5 5 0 0 0-10 0L92 37.25l-40 .1L51.66 5a5 5 0 0 0-10 0L42 37.38l-37 .09a5 5 0 0 0 0 10h6.26l-.37 24.3c-.49 32.4 23.78 59.14 54.1 59.6h2.24c-.69 16 7 43.7 40.27 46.59h.45a5.22 5.22 0 0 0 .44-10.42c-13.53-1.17-22.79-7.26-27.51-18.1a42.62 42.62 0 0 1-3.3-17.78v-.18c29.83-.18 54.3-25.9 54.79-57.91l.4-26.46h5.91a5 5 0 0 0 .02-9.98zm-16.3 36.32c-.4 26.55-20.92 47.77-45.73 47.4l-11.5-.17c-24.81-.39-44.67-22.26-44.27-48.77l.37-24.48 101.52-.26z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = ElectricPlug;